import { isNotDefined, getMACalculator } from "../utils";

const defaultOptions = {
  windowSize: 14,
  movingAverageType: "sma",
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, movingAverageType } = options;

    // Step 1: Calculate ratio = (Close - Open) / (High - Low) and add to data
    const dataWithRatio = data.map((d) => {
      let ratio;

      if (
        isNotDefined(d.close) ||
        isNotDefined(d.open) ||
        isNotDefined(d.high) ||
        isNotDefined(d.low)
      ) {
        ratio = undefined;
      } else {
        const numerator = d.close - d.open;
        const denominator = d.high - d.low;

        // Avoid division by zero
        if (denominator === 0) {
          ratio = undefined;
        } else {
          ratio = numerator / denominator;
        }
      }

      return { ...d, _bopRatio: ratio };
    });

    // Step 2: Apply moving average to the ratios
    const maCalculator = getMACalculator(movingAverageType);
    const ma = maCalculator().options({
      windowSize,
      sourcePath: "_bopRatio",
    });
    const maValues = ma(dataWithRatio);

    // Step 3: Extract just the MA values
    return maValues;
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
